import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";

// Better Auth client configured for your custom tables
export const authClient = createAuthClient({
  baseURL: process.env.NEXT_URL || "https://mahlia.network",
  basePath: "/api/auth",
});

// Custom hooks that work with your custom fields
export const {
  useSession,
  useSignIn,
  useSignUp,
  isLoading,
  useSignOut,
  useChangePassword,
  updateUser,
} = createAuthClient({
  plugins: [],
});

// Helper function to get user role from session
// export function getUserRole(session) {
//   return session?.user?.role || 'users';
// }

// // Helper function to check permissions
// export function hasPermission(session, permission) {
//   if (!session?.user?.permissions) return false;
//   return session.user.permissions[permission] === true;
// }

// // Helper function to check if user is admin
// export function isAdmin(session) {
//   return getUserRole(session) === 'admin';
// }
